import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCoOpComponent } from './simple-icons-co-op.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCoOpComponent ],
    exports:      [ SimpleIconsCoOpComponent ],
    bootstrap:    []
})
export class SimpleIconsCoOpModule {}
